import { formatCurrencyWithSubscript } from "../../utils/format";
import { getTradeEntryPrice } from "../../utils/trade";

export interface PnlTweetInput {
  direction: "Long" | "Short";
  instrumentName?: string;
  /** ROE text, e.g. "+12.50%". */
  roiText?: string;
  /** PnL in dollars, e.g. "+$120.00". */
  pnlText?: string;
  /** The position or trade; its entry price is read the same way the card does. */
  source?: Parameters<typeof getTradeEntryPrice>[0];
  appDomain: string;
}

/**
 * The share-to-X text. The "Entry:" line used to print the PnL dollars (#33);
 * it now prints the entry price, and the PnL sits beside the ROE.
 */
export const buildPnlTweetText = ({
  direction,
  instrumentName,
  roiText,
  pnlText,
  source,
  appDomain,
}: PnlTweetInput): string => {
  const entry = Number(getTradeEntryPrice(source));
  const entryText =
    Number.isFinite(entry) && entry > 0 ? formatCurrencyWithSubscript(entry) : "-";
  const result = [roiText, pnlText ? `(${pnlText})` : ""].filter(Boolean).join(" ");
  return [
    `${direction} ${instrumentName ?? ""} → ${result}`,
    `Entry: ${entryText}`,
    `\nTrade on APP.${appDomain.toUpperCase()}`,
  ].join("\n");
};
